import { Outlet } from "react-router-dom";

import AppBar from "@/components/layout/appBar/AppBar";
import SideBar from "@/components/layout/sidebar/SideBar";
import Intercom from "@intercom/messenger-js-sdk";
import useGetIntercom from "@/hooks/query/auth/useGetIntercome";
import { useEffect } from "react";
import useStoreMe from "@/hooks/store/useStoreMe";

function MainLayout() {
  const { data: intercomToken } = useGetIntercom();
  const { me } = useStoreMe();

  useEffect(() => {
    if (intercomToken?.token && me?.id && me?.email) {
      Intercom({
        app_id: "p92cguqm",
        user_id: me.id,
        name: me.firstName,
        email: me.email,
        intercom_user_jwt: intercomToken.token,
      });
    }
  }, [intercomToken?.token, me?.id, me?.email, me?.firstName]);
  const renderContent = () => {
    return (
      <div className="max-w-[100vw] overflow-hidden">
        <div className={`flex w-screen h-screen py-3 pe-3 bg-gray-50 gap-2 `}>
          <SideBar />
          <section className="flex flex-col flex-grow overflow-x-hidden bg-white border border-gray-100 rounded-[16px]">
            <AppBar />
            <div className="relative flex flex-col min-h-[700px] flex-grow overflow-auto">
              <Outlet />
            </div>
          </section>
        </div>
      </div>
    );
  };

  return renderContent();
}

export default MainLayout;
